import axios from "axios";
import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Slider from "react-slick";
import { ImageList } from "../../src/components/design-pages/imageList";

const tileData = [
  {
    src: "https://orientbell.com/media/design-images/Living Room/Artistic_living_room_design_showcasing_intricate_tile_patterns.webp",
    alt: "Sophisticated living room design showcasing wooden tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Bold_living_room_design_with_geometric_tiles_and_neutral_sofas.webp",
    alt: "Living room design showcasing floral wallpaper and modern aesthetics",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Bright_and_airy_living_room_design_with_creamy_tiles.webp",
    alt: "Artistic living room design showcasing intricate tile patterns",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Bright_living_room_design_with_full-height_glass_windows.webp",
    alt: "Combine sleek furniture with soft neutral tiles for modern living room design",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Chic_living_room_design_showcasing_intricate_blue_floral_wall_tiles.webp",
    alt: "Light flooring with dark accent walls for a dramatic living room design.",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Chic_living_room_design_with_grey_stone_tiles.webp",
    alt: "Marble tiles with gold veining for a sophisticated living room design",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Chic_living_room_design_with_textured_blue_feature_wall.webp",
    alt: "Living room design with large windows and natural greenery",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_artistic_wall_tiles.webp",
    alt: "Bright living room design with full-height glass windows",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_bold_geometric_accents.webp",
    alt: "Marble flooring with gold accents for a luxurious living room design",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_bright_marble_tiles.webp",
    alt: "Modern living room design with large windows & table chair set",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_cohesive_decor_and_subtle_lighting.webp",
    alt: "Modern living room design featuring golden tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_cream_brick_tiles_and_large_window.webp",
    alt: "Warm and inviting living room design with sand tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_polished_white_tiles_and_classy_furniture.webp",
    alt: "Living room design with beige wooden flooring",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_traditional_furniture_and_bold-colored_cushions.webp",
    alt: "Large glass windows with wooden tiles for living room design",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Classic_living_room_design_with_wooden_flooring_and_soft_beige_tiles.webp",
    alt: "Elegant brick accent living room design with unique perforated walls",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Combine_sleek_furniture_with_soft_neutral_tiles_for_modern_living_room_design.webp",
    alt: "Unique living room design with bold herringbone wood patterns",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Contemporary_black_and_white_living_room_design_with_marble-inspired_tiles.webp",
    alt: "Stylish living room design with marble flooring and garden access",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Contemporary_living_room_design_with_a_touch_of_modern_art.webp",
    alt: "Modern minimalist living room design with luxurious accent",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Contemporary_living_room_design_with_chevron_grey_tiles.webp",
    alt: "Contemporary living room design with geometric patterns",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Contemporary_living_room_design_with_geometric_patterns.webp",
    alt: "Elegant living room design with beige furniture and marble floor",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Contemporary_living_room_design_with_textured_walls_with_striped_wall_tiles.webp",
    alt: "Living room design with bold furniture and seamless tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Contemporary_living_room_design_with_unique_geometric_tiles.webp",
    alt: "Classic living room design with polished white tiles and classy furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Cozy_living_room_design_with_neutral_wood-look_tiles.webp",
    alt: "Chic living room design with textured blue feature wall",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Cozy_modern_living_room_design_with_comfortable_furniture.webp",
    alt: "Luxurious living room design with gold-accented mosaic tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_brick_accent_living_room_design_with_unique_perforated_walls.webp",
    alt: "Contemporary black and white living room design with marble-inspired tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_living_room_design_enhanced_by_geometric_grey_tiles.webp",
    alt: "Rustic modern living room design with combine batik-style tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_living_room_design_with_beige_furniture_and_marble_floor.webp",
    alt: "Living room design with grey brick-style tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_living_room_design_with_blue_floral_tiles.webp",
    alt: "Chic living room design showcasing intricate blue floral wall tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_living_room_design_with_floral_accent_wall.webp",
    alt: "Modern living room design with a striking checkered grey tile wall",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_living_room_design_with_marble-textured_walls_and_dark_wood_flooring.webp",
    alt: "Elegant living room design enhanced by a geometric grey tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_living_room_design_with_sleek_vitrified_tiles.webp",
    alt: "Living room design with combine minimalist furniture & natural textures",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_living_room_design_with_white_walls_and_vibrant_blue_tiles.webp",
    alt: "Contemporary living room design with textured walls with striped wall tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Elegant_modern_living_room_design_with_natural_lighting_and_modern_seating.webp",
    alt: "Living room design with durable wood-look tiles and white furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Large_glass_windows_with_wooden_tiles_for_living_room_design.webp",
    alt: "Modern living room design with dark wood furniture and soft lighting",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Light_flooring_with_dark_accent_walls_for_a_dramatic_living_room_design.webp",
    alt: "Luxury living room design with marble-inspired wall tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_showcasing_floral_wallpaper_and_modern_aesthetics.webp",
    alt: "Elegant living room design with marble-textured walls and dark wood flooring",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_beige_wooden_flooring.webp",
    alt: "Modern living room design with floral patterns wall",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_bold_furniture_and_seamless_tiles.webp",
    alt: "Classic living room design with traditional furniture and bold-colored cushions",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_combine_minimalist_furniture_&_natural_textures.webp",
    alt: "Warm and inviting living room design with beige and brown tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_durable_wood-look_tiles_and_white_furniture.webp",
    alt: "Stylish living room design with eye-catching mosaic tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_grey_brick-style_tiles.webp",
    alt: "Bold living room design with geometric tiles and neutral sofas",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_grey_palettes_and_decorative_tiles.webp",
    alt: "Elegant living room design with floral accent wall",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_large_windows_and_natural_greenery.webp",
    alt: "Minimalist living room design with sleek gray palette",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_marble_tiles_and_geometric_furniture.webp",
    alt: "Sophisticated living room design with textured walls and chic furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_sleek_furniture_and_vibrant_tile_panel.webp",
    alt: "Elegant living room design with blue floral tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Living_room_design_with_warm_wood_and_glossy_neutral_tiles.webp",
    alt: "Modern living room design with soft palm leaf patterns",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxurious_living_room_design_paired_with_glossy_black_marble_tiles.webp",
    alt: "Luxury living room design with centerpiece floral tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxurious_living_room_design_paired_with_gold_spider_marble_floors.webp",
    alt: "Stylish living room design with sophisticated marble look tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxurious_living_room_design_with_gold-accented_mosaic_tiles.webp",
    alt: "Timeless living room design with classic white marble tile",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxurious_living_room_design_with_golden_brown_marble_tiles.webp",
    alt: "Vibrant living room design with marble tiles and golden accents",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxurious_living_room_design_with_white_marble_tiles.webp",
    alt: "Cozy living room design with neutral wood look tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxury_living_room_design_with_centerpiece_floral_tiles.webp",
    alt: "Rustic living room design with intricate wood patterned tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxury_living_room_design_with_marble-inspired_wall_tiles.webp",
    alt: "Contemporary living room design with unique geometric tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Luxury_living_room_design_with_polished_dark_tiles.webp",
    alt: "Minimalist living room design with sleek marble effect tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Marble_flooring_with_gold_accents_for_a_luxurious_living_room_design.webp",
    alt: "Modern living room design with sleek marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Marble_tiles_with_gold_veining_for_a_sophisticated_living_room_design.webp",
    alt: "Classic living room design with artistic wall tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Minimalist_living_room_design_with_large_windows_and_sleek_furniture.webp",
    alt: "Modern rustic living room design with wood look tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Minimalist_living_room_design_with_sleek_gray_palette.webp",
    alt: "Sophisticated living room design with minimal decor",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Minimalist_living_room_design_with_sleek_grey_vitrified_tiles.webp",
    alt: "Elegant living room design with white walls and vibrant blue tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Minimalist_living_room_design_with_sleek_marble_effect_tiles.webp",
    alt: "Luxurious living room design with golden brown marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_brick_living_room_design_with_grey_textured_wall_tiles.webp",
    alt: "Modern living room design with geometric pattern tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_featuring_Golden_tiles.webp",
    alt: "Classic living room design with bright marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_a_striking_checkered_grey_tile_wall.webp",
    alt: "Luxurious living room design with white marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_dark_wood_furniture_and_soft_lighting.webp",
    alt: "Sleek modern living room design with grey tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_floral_grid_tiles.webp",
    alt: "Spacious living room design with glossy tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_floral_patterns_wall.webp",
    alt: "Modern living room design with white marble inspired tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_geometric_pattern_tiles.webp",
    alt: "Living room design with warm wood and glossy neutral tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_glossy_black_marble_tiles.webp",
    alt: "Cozy modern living room design with comfortable furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_grey_tile_sleek_patterns.webp",
    alt: "Trendy living room design with polished stone look flooring",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_large_windows_&_table_chair_set.webp",
    alt: "Elegant living room design with sleek vitrified tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_sleek_marble_tiles.webp",
    alt: "Minimalist living room design with sleek grey vitrified tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_soft_palm_leaf_patterns.webp",
    alt: "Modern living room design with white marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_white_marble-inspired_tiles.webp",
    alt: "Chic living room design with grey stone tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_design_with_white_marble_tiles.webp",
    alt: "Warm living room design with glossy beige tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_living_room_featuring_glossy_black_and_white_striped_tiles_for_walls_and_floors.webp",
    alt: "Elegant modern living room design with natural lighting and modern seating",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_minimalist_living_room_design_with_luxurious_accent.webp",
    alt: "Classic living room design with bold geometric accents",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_rustic_living_room_design_with_brick_and_sleek_interiors.webp",
    alt: "Rustic living room design with natural wood tones",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Modern_rustic_living_room_design_with_wood-look_tiles.webp",
    alt: "Luxury living room design with polished dark tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Nature-inspired_living_room_design_with_large_glass_windows.webp",
    alt: "Bright and airy living room design with creamy tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Patterned_living_room_design_with_bold_Moroccan-inspired_tiles.webp",
    alt: "Versatile living room design with neutral flooring and sleek tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Rustic_living_room_design_with_intricate_wood_patterned_tiles.webp",
    alt: "Stylish living room design with large window and sofas",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Rustic_living_room_design_with_Moroccan_mosaic_tiles_and_sleek_furniture.webp",
    alt: "Modern rustic living room design with brick and sleek interiors",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Rustic_living_room_design_with_natural_wood_tones.webp",
    alt: "Nature inspired living room design with large glass windows",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Rustic_modern_living_room_design_with_combine_batik-style_tiles.webp",
    alt: "Modern brick living room design with grey textured wall tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sleek_living_room_design_with_paired_furniture_and_scenic_tile_art.webp",
    alt: "Contemporary living room design with a touch of modern art",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sleek_modern_living_room_design_with_grey_tiles.webp",
    alt: "Classic living room design with wooden flooring and soft beige tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sophisticated_living_room_design_showcasing_wooden_tiles.webp",
    alt: "Sophisticated living room design with rich brown marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sophisticated_living_room_design_with_brown_tiles_and_plush_furniture.webp",
    alt: "Contemporary living room design with chevron grey tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sophisticated_living_room_design_with_minimal_decor.webp",
    alt: "Modern living room design with floral grid tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sophisticated_living_room_design_with_rich_brown_marble_tiles.webp",
    alt: "Rustic living room design with Moroccan mosaic tiles and sleek furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sophisticated_living_room_design_with_textured_walls_and_chic_furniture.webp",
    alt: "Sophisticated living room design with brown tiles and plush furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Spacious_living_room_design_with_glossy_tiles.webp",
    alt: "Sleek living room design with paired furniture and scenic tile art",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Stylish_living_room_design_with_eye-catching_mosaic_tiles.webp",
    alt: "Living room design with sleek furniture and vibrant tile panel",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Stylish_living_room_design_with_gloss_blue_marble_tiles.webp",
    alt: "Patterned living room design with bold Moroccan inspired tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Stylish_living_room_design_with_large_window_and_sofas.webp",
    alt: "Living room design with grey palettes and decorative tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Stylish_living_room_design_with_marble_flooring_and_garden_access.webp",
    alt: "Stylish living room design with symmetrical tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Stylish_living_room_design_with_marble_tiles_and_large_window.webp",
    alt: "Classic living room design with cream brick tiles and large window",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Stylish_living_room_design_with_sophisticated_marble_look_tiles.webp",
    alt: "Modern living room design with grey tile sleek patterns",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Stylish_living_room_design_with_symmetrical_tiles.webp",
    alt: "Minimalist living room design with large windows and sleek furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Sustainable_living_room_design_with_wood_brown_tiles.webp",
    alt: "Classic living room design with cohesive decor and subtle lighting",
  },

  {
    src: "https://orientbell.com/media/design-images/Living Room/Timeless_living_room_design_with_classic_white_marble_tile.webp",
    alt: "Luxurious living room design paired with glossy black marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Trendy_living_room_design_with_polished_stone-look_flooring.webp",
    alt: "Modern living room design with glossy black marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Unique_living_room_design_with_bold_herringbone_wood_patterns.webp",
    alt: "Stylish living room design with gloss blue marble tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Versatile_living_room_design_with_neutral_flooring_and_sleek_tiles.webp",
    alt: "Living room design with marble tiles and geometric furniture",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Vibrant_living_room_design_with_marble_tiles_and_golden_accents.webp",
    alt: "Luxurious living room design paired with gold spider marble floors",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Warm_and_inviting_living_room_design_with_beige_and_brown_tiles.webp",
    alt: "Modern living room featuring glossy black and white striped tiles for walls and floors",
  },
  {
    src: "https://orientbell.com/media/design-images/Living Room/Warm_and_inviting_living_room_design_with_Sand_tiles.webp",
    alt: "Sustainable living room design with wood brown tiles",
  },
];

const faqs = [
  {
    question: "What factors should I consider when designing a living room?",
    answer:
      "For a living room to be designed, consider functionality, ultimate comfort & style. First is the layout and how it holds up to all your daily activities. Be mindful of having clear pathways and ample seating. After this, pick a colour scheme complementing the general decoration in your house. Again, you will want durable and stylish floor tiles that will survive foot traffic and spills without much hassle. Finally, pick furniture and other decor, offering harmony and practicality. ",
  },
  {
    question: "How to make sure your small living room looks more spacious?",
    answer:
      "Go with light-coloured floor and wall tiles, as these will help reflect more light and make it airy. Add in multi-functional furniture that saves space, like a sofa bed or a storage ottoman. Arrange your furniture to have a good flow and do not crowd it. Install mirrors to add the illusion of a larger space by reflecting light. Try to utilise the vertical space by adding shelves and other hanging decorations on walls. ",
  },
  {
    question: "What are some of the trends popular in living room design?",
    answer:
      "The design of modern living rooms has moved towards the use of natural materials, simple decoration, and open-floor plans. Tiles, especially large format ceramics and wood-look options, have become popular on the floor. Furniture with clean and simple shapes has remained stylish. The use of eco-friendly materials is getting popular, indicating deeper engagement with environmental responsibility.",
  },
  {
    question: "How to choose the right furniture for my living room?",
    answer:
      "Start primarily with considering the size of your room and its decor. Look for comfort and functionality. Modular furniture is great for flexibility while choosing a style that creates harmony. Go in for versatile furniture that can be used for different purposes, like modular sofas or nesting tables. Last but not least, ensure comfort through well-padded seats and ergonomic designs.",
  },
  {
    question: "What lighting is best for a living room?",
    answer:
      "Ambient, task, and accent lighting combine to give the best lighting for a living room. Ceiling fixtures or recessed lights can help create general illumination. Adding accent lighting by putting wall sconces or LED strips will draw attention to your artwork or architectural features. Dimmer switches also are fabulous, allowing modification of light levels to create the desired ambience at any time of the day. ",
  },
  {
    question:
      "Should I hire a professional designer or can I design my living room?",
    answer:
      "This depends on your confidence, the budget, and the complexity of the project. For bigger or more complex designs, a professional can save you time and help avoid costly mistakes. However, if you have a clear vision, enjoy DIY projects, and are on a budget, designing your living room can be very rewarding.",
  },
];
const settings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 641,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
};
const text = `More than just a room, the living room is the heart of your home—where ordinary moments turn into fond memories. It's where laughter echoes, stories are shared, and quiet moments of connection unfold. Your living room should reflect who you are, blending comfort with style. Whether you prefer a warm, cosy feel or a sleek, modern look, we have plenty of ideas to help you create the perfect living room. Discover our extensive range of handpicked living room interior designs and décor ideas. Let Orientbell Tiles be your partner in designing a living room that you'll love coming home to.`;

function LivingRoomDesigns() {
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => {
    getRelatedBlogs();
  }, []);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const getRelatedBlogs = async () => {
    try {
      let apiresult = await axios.get(
        `https://proxy.orientbell.com/blog/wp-json/post/v2/category/term=bathroom-designs`
      );
      
      setRelatedBlogData(apiresult);
    } catch (err) {
      console.log("Error in fetching blogs", err);
    }
  };
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);

  const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);
  return (
    <>
      <Head>
        <title>Living Room Interior Designs Ideas | Orientbell</title>
        <meta
          name="title"
          content="Living Room Interior Designs Ideas | Orientbell"
        />
        <meta
          name="description"
          content="Explore our gallery of stunning living room interior design ideas. Find inspiration for your hall and drawing room design with the latest living room trends ideas. Transform your home with our expert ideas and inspiration."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.orientbell.com/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Design Ideas",
                  item: "https://www.orientbell.com/design-ideas/",
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: "Living Room Designs",
                  item: "https://www.orientbell.com/design-ideas/living-room-designs",
                },
              ],
            }),
          }}
        ></script>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              url: "design-ideas/living-room-designs",
              headline: "",
              breadcrumb: "Home > Design Ideas > Living Room Designs",
              name: "Living Room Interior Designs Ideas | Orientbell",
              description:
                "Explore our gallery of stunning living room interior design ideas. Find inspiration for your hall and drawing room design with the latest living room trends ideas. Transform your home with our expert ideas and inspiration.",
            }),
          }}
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "What factors should I consider when designing a living room?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "For a living room to be designed, consider functionality, ultimate comfort & style. First is the layout and how it holds up to all your daily activities. Be mindful of having clear pathways and ample seating. After this, pick a colour scheme complementing the general decoration in your house. Again, you will want durable and stylish floor tiles that will survive foot traffic and spills without much hassle. Finally, pick furniture and other decor, offering harmony and practicality.",
                  },
                },
                {
                  "@type": "Question",
                  name: "How to make sure your small living room looks more spacious?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Go with light-coloured floor and wall tiles, as these will help reflect more light and make it airy. Add in multi-functional furniture that saves space, like a sofa bed or a storage ottoman. Arrange your furniture to have a good flow and do not crowd it. Install mirrors to add the illusion of a larger space by reflecting light. Try to utilise the vertical space by adding shelves and other hanging decorations on walls..",
                  },
                },
                {
                  "@type": "Question",
                  name: "What are some of the trends popular in living room design?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "The design of modern living rooms has moved towards the use of natural materials, simple decoration, and open-floor plans. Tiles, especially large format ceramics and wood-look options, have become popular on the floor. Furniture with clean and simple shapes has remained stylish. The use of eco-friendly materials is getting popular, indicating deeper engagement with environmental responsibility.",
                  },
                },
                {
                  "@type": "Question",
                  name: "How to choose the right furniture for my living room?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Start primarily with considering the size of your room and its decor. Look for comfort and functionality. Modular furniture is great for flexibility while choosing a style that creates harmony. Go in for versatile furniture that can be used for different purposes, like modular sofas or nesting tables. Last but not least, ensure comfort through well-padded seats and ergonomic designs.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What lighting is best for a living room?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Ambient, task, and accent lighting combine to give the best lighting for a living room. Ceiling fixtures or recessed lights can help create general illumination. Adding accent lighting by putting wall sconces or LED strips will draw attention to your artwork or architectural features. Dimmer switches also are fabulous, allowing modification of light levels to create the desired ambience at any time of the day.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Should I hire a professional designer or can I design my living room?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "This depends on your confidence, the budget, and the complexity of the project. For bigger or more complex designs, a professional can save you time and help avoid costly mistakes. However, if you have a clear vision, enjoy DIY projects, and are on a budget, designing your living room can be very rewarding.",
                  },
                },
              ],
            }),
          }}
        ></script>
      </Head>

      <div className="designpage-section">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.orientbell.com">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/living-room-designs">
              Living Room Designs
            </Breadcrumb.Item>
          </Breadcrumb>

          <div className="designpage-heading-bx padding-spacing">
            <h4>Showing {tileData.length} results for </h4>
            <h1>Living Room Interior Designs</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div className="obl-master-design-section">
            <h2>Living Room Design Gallery</h2>
            <div className="designpage-category-row inner-design-gallery">
              <ImageList tileData={tileData} />
            </div>

            <div className="bottom-content">
              <div className="common-text-content-section">
                <h2>Functional & Stylish Living Room Interior Design Ideas</h2>
                <p>
                  Style and functionality in a living room require planning. You
                  should keep below points in mind to achieve a living room
                  space of a kind:
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Get Furniture with Storage</strong>
                    </h5>
                    <p>
                      Go for furniture that provides storage (like sofas with
                      under-drawer spaces) yet blends seamlessly into your
                      living room decor interior. This will help retain
                      functionality in the space without getting overwhelmed and
                      make the space versatile.{" "}
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Use Tonal Colors and Patterns</strong>
                    </h5>
                    <p>
                      Embrace a decorating style that uses monochromatic tones
                      or subtle patterns to avoid clutter. Incorporating a
                      pastel paint job or sticking to a cohesive colour palette
                      can balance bold elements and add warmth to your room.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Maximise Vertical Space</strong>
                    </h5>
                    <p>
                      Install high shelves and utilise wall tile design to keep
                      the floor area open. This builds an aura of larger space
                      and ensures your living room floor tiles have some
                      flexibility.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Focus on Lighting </strong>
                    </h5>
                    <p>
                      Use lighting to define different areas within your space,
                      like a statement pendant over a dining spot.
                      Alternatively, the glossy wall tile can play with the
                      natural light and create subtle warm lighting all around.
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Use Different Design Elements </strong>
                    </h5>
                    <p>
                      Add special elements like textured wall tiles, bold
                      furniture, and decorative accessories to give your living
                      room more character. Play with textures, patterns, and
                      colours using throw pillows, rugs, and curtains. Combine
                      materials like wood, metal, and glass to create a
                      balanced, stylish space that reflects your personality
                      while staying practical.
                    </p>{" "}
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2> Small Living Room Designs</h2>
                <p>
                  Designing a small living room can be quite a challenge, but it
                  will be easy to maximise all the space available with the
                  right strategies. Look out for some key tips:
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>{`Highlight Room's Features`}</strong>
                    </h5>
                    <p>
                      Make the most of the features like curved or angled
                      ceilings to create a sense of height and openness. Use
                      light, neutral colours to brighten the room and a
                      monochromatic design with soft patterns to maintain a
                      calm, cohesive look. Add textured elements like wooden
                      beams or trims to enhance the charm.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Choose Open and Smart Furniture</strong>
                    </h5>

                    <p>
                      Pick low-profile furniture like daybed-style sofas that
                      don’t block sightlines, making the room feel more
                      spacious. Include multifunctional pieces like ottomans or
                      benches with hidden storage to maximise utility. Flexible
                      seating arrangements, like stackable chairs or foldable
                      tables, are perfect for adapting to different occasions or
                      gatherings.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Use Vertical Space</strong>
                    </h5>
                    <p>
                      Install tall shelves or wall-mounted units to keep the
                      floor clear and provide ample storage. Add wallpaper or
                      paint to the ceiling with subtle patterns or designs to
                      draw attention upward, making the room feel larger. Pair
                      this with compact tile designs, like those from Orientbell
                      Tiles, to create a cohesive look that balances style and
                      space efficiency.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Keep Accessories Minimal</strong>
                    </h5>
                    <p>
                      Choose a few statement pieces, like a sleek vase or a
                      stylish clock, to maintain a clean look. Use lighting
                      strategically to define areas, such as pendant lights for
                      dining spaces or floor lamps for reading nooks. Layer
                      different types of lighting, like ambient, task, and
                      accent lights, to add depth and warmth without
                      overwhelming the room.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>Luxury Living Room Designs</h2>
                <p>
                  A luxury living room involves a blend of comfort and high-end
                  aesthetics. Following are some ideas to help you achieve a
                  luxurious living space:
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong> Style Vertical Space: </strong>
                    </h5>
                    <p>
                      Use tall bookcases for high ceilings or hang a grand
                      chandelier to make a statement.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Add Statement Lighting:</strong>
                    </h5>
                    <p>
                      Choose eye-catching chandeliers or pendant lights. Use
                      different sizes and heights for a dramatic effect. Combine
                      different lighting styles to highlight features and create
                      a warm, inviting vibe.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Play with Textures:</strong>
                    </h5>
                    <p>
                      Use plush fabrics, rich materials, or textured walls to
                      add depth and interest to your space. These simple updates
                      can transform your living room.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Bring in Feature Walls:</strong>
                    </h5>
                    <p>
                      Design a striking focal point with an accent wall. Common
                      ways to create a feature wall include using bold paint
                      colours, wallpaper or accent tiles. Pair this with modern
                      floor tiles to maintain a chic look.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Use Metallic Accents: </strong>
                    </h5>
                    <p>
                      Add metallic elements like gold or silver finishes, or
                      decorative pieces, to add a touch of luxury. For example,
                      a gold-framed mirror or silver candle holder can enhance
                      the elegance of the space.
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Highlight Textures: </strong>
                    </h5>
                    <p>
                      Bring in texture with plush fabrics, rich materials, and
                      even textured walls to create depth and interest. These
                      decor ideas will give your living space the update it
                      needs.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>Explore Colour Ideas For Your Living Room Design</h2>
                <p>
                  To pick the right colours for your living room is a primary
                  step towards transforming the space and making it both
                  inviting and stylish. Here are some top living room design
                  colour ideas to consider:
                </p>
                <ul>
                  <li>
                    {" "}
                    <h5>
                      <strong> Rich Neutrals: </strong>
                    </h5>
                    <p>
                      Beige, taupe, and cream hues display a warm and classy
                      background. These tones go perfectly with the{" "}
                      <a href="https://www.orientbell.com/tiles/living-room-tiles">
                        living room tiles{" "}
                      </a>
                      from Orientbell Tiles in shades of beige or cream, adding
                      class to the room. They can be easily matched with
                      different textures and patterns to add depth and interest
                      to your living space. This simple living room wall colour
                      design is perfect for a timeless look.
                    </p>
                  </li>

                  <li>
                    {" "}
                    <h5>
                      <strong> Bold Accents: </strong>
                    </h5>
                    <p>
                      Some of the colours such as navy blue, emerald green, or
                      red add drama and depth. Use them on accent walls or in
                      accessories to create focal points. Bold living room
                      colours make a statement and add character to your living
                      room design. Pair these with blue, white or glossy marble
                      floor tiles and contrast decor elements for a striking
                      effect.
                    </p>
                  </li>
                  <li>
                    {" "}
                    <h5>
                      <strong> Soft Pastels: </strong>
                    </h5>
                    <p>
                      Light blues, pinks, and greens are all calming colours
                      that easily work with natural light. They let the space
                      have a light, open feel. This simple living room wall
                      colour design enhances tranquillity.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Earthy Tones: </strong>
                    </h5>
                    <p>
                      Browns, terracottas, and olive greens connect your living
                      room design with nature, creating a cosy and grounded
                      atmosphere. Pair these with living room floor tiles in
                      brown or green shade to enhance the earthy vibe and bring
                      a touch of the outdoors inside.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Monochromatic Schemes: </strong>
                    </h5>
                    <p>
                      Different shades of a single colour could be used to bring
                      about cohesion in the space. Adding{" "}
                      <a href="https://www.orientbell.com/tiles/living-room-tiles">
                        living room floor tiles{" "}
                      </a>
                      in grey or white shades can create an unbroken and stylish
                      look in the living room, blending everything. A
                      well-chosen living room paint colour can significantly
                      influence the overall design style and ambience of the
                      space.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>How to Design the Living Room of Your Dreams?</h2>
                <p>
                  A dream living room is all about comfort and style, tailored
                  to your taste while being practical. Start by exploring
                  different living room designs like traditional, contemporary,
                  or rustic to see what fits your personality. Enhance the
                  atmosphere with well-thought-out lighting, deep colours for
                  added depth, and the right floor tiles. Mix textures to create
                  visual interest and make the space uniquely yours.
                </p>
                <p>
                  {" "}
                  {`Add personal touches like statement walls to add style to your
                  decor. For example, a feature wall with a bold paint colour or
                  textured wallpaper can instantly elevate the room's look. You
                  could also consider a wooden accent wall or a gallery wall
                  with framed artwork and photographs to give the space a
                  unique, personal feel.`}
                </p>
                <p>
                  Decorative accents such as artwork and textiles can reflect
                  your personality. Play around with furniture arrangements to
                  maximise space and ensure comfort. By blending your favourite
                  design style with practical elements, you can create a living
                  room that’s not only beautiful but also comfortable. With
                  Orientbell Tiles, you can bring your dream living room to life
                  and enjoy it every day.
                </p>
              </div>

              <div className="common-text-content-section">
                <h2>How to Choose Perfect Living Room Design?</h2>
                <p>
                  The perfect living room design would decide how much of your
                  style is reflected and how enhanced your home interiors can
                  be. Following are some pointers to help you get through the
                  process:
                </p>
                <ul>
                  <li>
                    {" "}
                    <h5>
                      <strong> Understand Your Needs: </strong>
                    </h5>
                    <p>
                      Decide if your living room is for relaxing, working, or
                      entertaining. Plan its function accordingly.
                    </p>
                  </li>

                  <li>
                    {" "}
                    <h5>
                      <strong> Plan the Layout: </strong>
                    </h5>
                    <p>
                      {`Check the room's size and shape to arrange furniture and
                      focal points like a TV or fireplace.`}
                    </p>
                  </li>
                  <li>
                    {" "}
                    <h5>
                      <strong>Pick a Style: </strong>
                    </h5>
                    <p>
                      Choose a theme—modern, traditional, or minimalist—and
                      select colours and patterns that match.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Choose the Right Flooring: </strong>
                    </h5>
                    <p>
                      Select flooring that suits your style and lifestyle. For
                      warmth and durability, try wooden tiles, or explore our
                      collections for modern designs.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Lighting Matters: </strong>
                    </h5>
                    <p>
                      Organise the space with ambient, task, and accent lighting
                      to create a functional area, ambiently lit yet inviting.
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Accessorise Thoughtfully: </strong>
                    </h5>
                    <p>
                      Play with decorative elements like rugs, pictures or even
                      plants to give the interior decor some personality and
                      texture.
                    </p>
                  </li>
                </ul>
                <p>
                  These simple steps can help you design a stylish and
                  functional living room that feels comfortable and welcoming.
                </p>
              </div>

              <div className="common-text-content-section">
                <h2>How Do You Make Your Living Room Look Luxury?</h2>
                <p>
                  Creating a luxurious living space isn’t about copying a
                  perfect setup but about designing a room that feels elegant
                  and reflects your style. Start with furniture made of solid
                  wood, leather, or plush fabrics—think Chesterfield sofas or
                  marble-top coffee tables for a touch of sophistication. Use
                  glossy marble tiles with rich veining to add a luxurious feel
                  to your walls. Go for matte-finish large tiles for the floors.
                  They create a jointless look and open up the room to make it
                  look spacious.
                </p>
                <p>
                  {" "}
                  Choose a neutral colour palette like beige or grey, and pair
                  it with rich shades like navy, emerald, or gold to create
                  depth and a calming vibe. Highlight the space with statement
                  lighting such as chandeliers or modern pendant lights to add a
                  striking focal point.
                </p>
                <p>
                  Use silk cushions, velvet fabrics, and wool rugs to add
                  texture and comfort. Finally, decorate with carefully chosen
                  artwork and quality decor to make the room personal and
                  luxurious.
                </p>
              </div>
            </div>
            <div className="designpage-faq-section padding-spacing">
              <h2>FAQs About Living Room Design</h2>
              <div className="newacd designpage-faq-row">
                <ul className="accordion">
                  {displayedFAQs.map((faq, index) => (
                    <li key={index}>
                      <a className="toggle" onClick={() => handleToggle(index)}>
                        {index + 1}. {faq.question}
                      </a>
                      {activeIndex === index && (
                        <ul className="inner">
                          <li>{faq.answer}</li>
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                {faqs.length > 5 && (
                  <div className="tru_btn_new design-page">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {showAll ? "Show Less" : "Read More"}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {relatedBlogData?.length > 0 && (
              <div className="tile-related-blog">
                <h2 className="title">Related Blogs</h2>
                <div className="designpage-relatedpost-row">
                  <Slider {...settings}>
                    {relatedBlogData?.map((obj, index) => {
                      return (
                        <div className="related-blog-col" key={index}>
                          <div className="blog-figure">
                            <a href={obj.permalink}>
                              <img
                                src={obj.image}
                                loading="lazy"
                                alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                              />
                            </a>
                          </div>
                          <div className="blog-text">
                            <div className="listingDate">{obj.date}</div>
                            <div className="listingHead">
                              <a href={obj.permalink}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.title,
                                  }}
                                />
                              </a>
                            </div>
                            <div className="listingText">
                              <p>
                                {" "}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.content.slice(0, -11),
                                  }}
                                />
                              </p>
                              <div className="listingButton">
                                <a href={obj.permalink}>Read More</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default LivingRoomDesigns;
